import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import type { BackupJob, InventoryResource, RestoreJob, ScanJob } from '@repo/api-gw-sdk';
import { CloudProviderIndicator } from '../cloudProviderIndicator';
import { isJob, isRestoreJob } from '../queryBuilder/properties';
import { CellActionsWrapper } from '../table/cellActionsWrapper';
export const CloudAccountCell = entity => {
  const $ = _c(3);
  const providerAccountId = isJob(entity) ? isRestoreJob(entity) ? entity.destinationDetails.providerAccountId : entity.resourceDetails?.providerAccountId : entity.providerAccountId;
  const cloudProvider = isJob(entity) ? isRestoreJob(entity) ? entity.destinationDetails.cloudProvider : entity.resourceDetails?.cloudProvider : entity.cloudProvider;
  let t0;
  if ($[0] !== cloudProvider || $[1] !== providerAccountId) {
    t0 = providerAccountId && <CellActionsWrapper textToCopy={providerAccountId}><Stack overflow="hidden" maxWidth="200px">{cloudProvider ? <CloudProviderIndicator cloudProvider={cloudProvider} text={providerAccountId} /> : <Typography>{providerAccountId}</Typography>}</Stack></CellActionsWrapper>;
    $[0] = cloudProvider;
    $[1] = providerAccountId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};